import * as Api from '../../../api/Api';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { PageTitle } from '../../../../_metronic/layout/core';
import Modal from 'react-bootstrap/Modal';
import { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";

export default function Bloquear_Cierre({ title }) {


    const [ultimoCierre, setUltimoCierre] = useState({ ultimaFechaCierre: null, cierreBloqueado: null });
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);
    const [setDatos, setSetDatos] = useState(false);

    const token = useGetToken();

    const [date, setDate] = useState(new Date());
    let dateFormated = ("0" + (date.getDate())).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear()

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError, error } = useQuery(
        ["GetBloquearCierre", {
        }],
        async () => await Api.GetBloquearCierre(
            { token: token }
        ),
        { enabled: true }
    );
    useEffect(() => {
        if (data) {
            if (data.data === null) {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else {
                setUltimoCierre(data.data);
            }
        }
    }, [data]);

    let { data: dataSetCierre, isLoading: isLoadingCierre, isError: isErrorSetCierre, error: errorSetCierre, isFetching: isFetchingSetCierre } = useQuery(
        ["SetBloquearCierre", { dateFormated: dateFormated }],
        async () => await Api.SetBloquearCierre(
            {
                dateFormated: dateFormated,
                token: token
            }
        ),
        { enabled: Boolean(setDatos) }
    );
    useEffect(() => {
        if (dataSetCierre != undefined)
            if (dataSetCierre) {
                console.log(dataSetCierre);
                setSetDatos(false);
                setGuardadoExitoso(true);
            }
            else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataSetCierre.errorId });
            }
    }, [dataSetCierre]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.BLOQUEAR_CIERRES]} >
                <PageTitle>{title}</PageTitle>
                <div className="card">

                    <div className="card-body">

                        <div className="card-px text-center pt-15 pb-5">

                            {(Boolean(ultimoCierre.cierreBloqueado)) ?
                                <div><h2 className="fs-2x fw-bolder mb-0">Fecha de cierre: {ultimoCierre.ultimaFechaCierre}</h2><p className="text-gray-400 fs-4 fw-bold py-7">Se ha finalizado el cierre, intente la proxima fecha.</p></div> :
                                <div><h2 className="fs-2x fw-bolder mb-0">Bloquear Cierres al  {dateFormated}</h2><p className="text-gray-400 fs-4 fw-bold py-7">Haga clic en el a continuación para bloquear los cierres.</p></div>
                            }



                            <button
                                type="button"
                                disabled={Boolean(ultimoCierre.cierreBloqueado)}
                                className={Boolean(ultimoCierre.cierreBloqueado) ? "btn btn-secondary fs-6 px-8 py-4" : "btn btn-dark fs-6 px-8 py-4"}
                                onClick={() => setSetDatos(true)}
                            >
                                Bloquear
                            </button>
                            {(setDatos) && <div className="spinner-border"></div>}

                        </div>
                        <div className="text-center pb-15 px-5">
                            <img src="../media/mall-girl.png" alt="" className="mw-100 h-150px h-sm-325px"></img>

                        </div>

                    </div>

                </div>

                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Cierre Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={() => { setGuardadoExitoso(false); window.location.reload(false); }}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>
        </>
    )
}